import { SERVICES } from "@/data/services";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {SERVICES.map((s) => (
      <span key={s.slug} className="flex items-center">
        <span className="flex items-baseline gap-4 px-8 md:px-12">
          <span className="font-display text-4xl font-extrabold tracking-tight text-[#0D9488] md:text-6xl">{s.verb}</span>
          <span className="font-display text-lg font-light text-[#2D6A64] md:text-2xl">{s.title}</span>
        </span>
        <span className="h-3 w-3 rotate-45 bg-[#D4AF37]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[#E2ECEB] py-10 md:py-14" data-testid="editorial-marquee">
    <div className="kz-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
